import { Box, Divider, MediaBox, Typography } from "@jewlr/storybook/core"
import React from "react"
import { Link } from "react-router-dom"

const JahnaviMala = () => (
  <Box contain>
    <MediaBox
      greaterThanOrEqual="tablet"
      height="207px"
      style={{
        backgroundImage:
          "url(" + require("images/malas/infopage_01_background.jpg") + ")",
        backgroundPositionX: "center",
      }}
      textAlign="center"
      width="100%"
    >
      <Box>
        <Box
          as="img"
          pt={3}
          src={require("images/malas/infopage_01_title1.png")}
          width="43%"
        />
      </Box>
      <Box>
        <Box
          as="img"
          src={require("images/malas/infopage_01_title2.png")}
          width="43%"
        />
      </Box>
    </MediaBox>
    <MediaBox lessThan="tablet">
      <Box
        as="img"
        pt={3}
        src={require("images/malas/infopage_mobile2_01title.png")}
        width="100%"
      />
    </MediaBox>
    <MediaBox greaterThanOrEqual="tablet">
      <Box
        height="759px"
        style={{
          backgroundImage:
            "url(" + require("images/malas/infopage_02.jpg") + ")",
          backgroundPositionX: "center",
        }}
        width="100%"
      ></Box>
    </MediaBox>

    <MediaBox
      height="411px"
      lessThan="tablet"
      style={{
        background: "center",
        backgroundImage:
          "url(" + require("images/malas/infopage_mobile2_01.jpg") + ")",
      }}
      width="100%"
    >
      <Box textAlign="center">
        <Box mt="25px">
          <source
            media="(max-width: 767px)"
            sizes="100vw"
            srcSet={`
              ${require("images/malas/infopage_mobile2_03_title.png")} 767w
            `}
          />
          <source
            media="(min-width: 533px)"
            sizes="330px"
            srcSet={`
              ${require("images/malas/infopage_03_title1.png")} 1920w,
            `}
          />
          <Box
            as="img"
            mb={1}
            src={require("images/malas/infopage_mobile2_03_title.png")}
            width="50%"
          />
        </Box>

        <Typography
          as="p"
          color="#2c5027"
          fontSize="12px"
          mb={6}
          mt="25px"
          mx="40px"
        >
          For thousands of years, malas have been used by yogis and spiritual
          seekers for meditation. They are comprised of 108 beads of
          semi-precious stones that are specifically selected for their unique
          vibrations and healing qualities.
        </Typography>
        <Typography
          as={Link}
          backgroundColor="#2c5027"
          color="white"
          data-lc="jahnavi-mala-project"
          px="40px"
          py="10px"
          to="/mala-collection"
        >
          SHOP MALA COLLECTION
        </Typography>
      </Box>
    </MediaBox>
    <MediaBox
      greaterThanOrEqual="tablet"
      height="613px"
      style={{
        backgroundImage:
          "url(" + require("images/malas/infopage_03_background.jpg") + ")",
        backgroundPositionX: "center",
      }}
      width="100%"
    >
      <Box textAlign="center">
        <Box>
          <source
            media="(max-width: 767px)"
            sizes="100vw"
            srcSet={`
              ${require("images/malas/infopage_mobile2_03_title.png")} 767w
            `}
          />
          <source
            media="(min-width: 533px)"
            sizes="330px"
            srcSet={`
              ${require("images/malas/infopage_03_title1.png")} 1920w,
            `}
          />
          <Box
            as="img"
            mb={1}
            pt="100px"
            src={require("images/malas/infopage_mobile2_03_title.png")}
            width="35%"
          />
        </Box>

        <Typography
          as="p"
          color="#2c5027"
          fontSize="16px"
          left="50%"
          ml="-195px"
          position="relative"
          top="20px"
          width="390px"
        >
          For thousands of years, malas have been used by yogis and spiritual
          seekers for meditation. They are comprised of 108 beads of
          semi-precious stones that are specifically selected for their unique
          vibrations and healing qualities.
        </Typography>
        <Typography
          as={Link}
          backgroundColor="#2c5027"
          color="#fff"
          data-lc="jahnavi-mala-project"
          fontSize="20px"
          position="relative"
          px="40px"
          py="10px"
          textTransform="uppercase"
          to="/mala-collection"
          top="50px"
        >
          Shop Mala Collection
        </Typography>
      </Box>
    </MediaBox>
    <MediaBox
      greaterThanOrEqual="tablet"
      height="533px"
      mb={3}
      style={{
        backgroundImage:
          "url(" + require("images/malas/infopage_04_background.jpg") + ")",
        backgroundPositionX: "center",
      }}
      width="100%"
    >
      <Box textAlign="center">
        <Box
          left="-180px"
          ml="-155px"
          position="relative"
          py="20px"
          top="150px"
        >
          <picture>
            <source
              media="(max-width: 767px)"
              sizes="100vw"
              srcSet={`
              ${require("images/malas/infopage_mobile2_04_title.png")} 767w
            `}
            />
            <source
              media="(min-width: 533px)"
              sizes="330px"
              srcSet={`
              ${require("images/malas/infopage_04_title1.png")} 1920w,
            `}
            />
            <Box
              as="img"
              mb={1}
              src={require("images/malas/infopage_mobile2_04_title.png")}
              width="35%"
            />
          </picture>
        </Box>
        <Typography
          as="p"
          color="white"
          fontSize="14px"
          left="50%"
          ml="-455px"
          position="relative"
          top="140px"
          width="393px"
        >
          Rudraksha beads, actually a seed, are known to last up to 8
          generations. They are believed to increase clarity, calm the nervous
          system, quiet the mind, and free negative thoughts.
        </Typography>
      </Box>
    </MediaBox>
    <MediaBox
      height="303px"
      lessThan="tablet"
      style={{
        backgroundImage:
          "url(" + require("images/malas/infopage_mobile2_02.jpg") + ")",
        backgroundPositionX: "50%",
      }}
      width="100%"
    >
      <Box
        backgroundColor="whitesmoke"
        display="inline-block"
        mx="50px"
        my="50px"
        opacity="0.8"
        pb="10px"
        px="10px"
        textAlign="center"
      >
        <Box>
          <Box
            as="img"
            pt={3}
            src={require("images/malas/infopage_mobile2_04_title.png")}
            width="100%"
          />
        </Box>
        <Typography
          as="p"
          backgroundColor="whitesmoke"
          color="#2c5027"
          fontSize="12px"
          textAlign="center"
        >
          Rudraksha beads, actually a seed, are known to last up to 8
          generations. They are believed to increase clarity, calm the nervous
          system, quiet the mind, and free negative thoughts.
        </Typography>
      </Box>
    </MediaBox>
    <Box
      backgroundColor={{ _: "#2c5027", tablet: "white" }}
      height="580px"
      pt={2}
      textAlign="center"
    >
      <picture>
        <source
          media="(max-width: 767px)"
          sizes="100vw"
          srcSet={`
              ${require("images/malas/infopage_mobile2_05_title.png")} 767w
            `}
        />
        <source
          media="(min-width: 768px)"
          sizes="330px"
          srcSet={`
              ${require("images/malas/infopage_05_title1.png")} 1920w,
            `}
        />
        <Box
          as="img"
          mb={1}
          src={require("images/malas/infopage_mobile2_05_title.png")}
          width="45%"
        />
      </picture>
      <Box mx={{ _: "40px", tablet: "" }} textAlign="-webkit-center">
        <Typography
          as="p"
          color={{ _: "white", tablet: "#2c5027" }}
          fontSize={{ _: "12px", tablet: "16px" }}
          id="first"
          mb="25px"
          width={{ _: "290px", tablet: "830px" }}
        >
          In the heart of the Himalayas, on the bank of the holy Ganga River is
          a little town called Uttarkashi, the northern town of Lord Siva. For
          years, Yogis, Sadhus, and seekers of Truth have visited this sacred
          place to practice meditation, study the scriptures and experience its
          unique spiritual vibration. Hidden among the Himalayan peaks are a
          number of old villages populated by the Garhwali people.
        </Typography>

        <Typography
          as="p"
          color={{ _: "white", tablet: "#2c5027" }}
          fontSize={{ _: "12px", tablet: "16px" }}
          id="second"
          mb="25px"
          width={{ _: "290px", tablet: "830px" }}
        >
          The beauty, simplicity and serenity of these villages and their people
          is timeless and pure. The scriptures call this area ‘Deva Boomi’ (The
          Land of the Gods). However, the challenges that these people face in
          their daily lives is enormous. Young children walk two hours to school
          every morning and two hours back in the evening, having to traverse an
          altitude of over 900ft.The women face the daily hardships of
          housework, tending the livestock and working the fields.
        </Typography>

        <Typography
          as="p"
          color={{ _: "white", tablet: "#2c5027" }}
          fontSize={{ _: "12px", tablet: "16px" }}
          id="third"
          mb="25px"
          width={{ _: "290px", tablet: "830px" }}
        >
          The mala project was created as an initiative to improve the quality
          of life of the Garhwali people. The women have been given an
          opportunity to make the malas. Each mala has been hand crafted by the
          women for which they earn an income. The remaining proceeds go to
          improved education and educational infrastructure for the children.
          Education is an inalienable right of every child.
        </Typography>
      </Box>
    </Box>
    <MediaBox lessThan="tablet">
      <Box
        height="189px"
        style={{
          backgroundImage:
            "url(" + require("images/malas/infopage_mobile2_04.jpg") + ")",
          backgroundPositionX: "50%",
        }}
        width="100%"
      ></Box>
    </MediaBox>
    <MediaBox lessThan="tablet">
      <Typography
        as="p"
        color="black"
        fontSize="12px"
        mx="50px"
        my="50px"
        textAlign="center"
      >
        Education is the right of every child. The Jahnavi Project is an
        initiative to improve education and educational infrastructure for the
        children of the villages, together with{" "}
        <Typography
          as="a"
          color="grey"
          fontSize="12px"
          href="https://kashika.org"
        >
          Kashika.org
        </Typography>
      </Typography>
    </MediaBox>

    <MediaBox lessThan="tablet">
      <Box
        height="275px"
        style={{
          backgroundImage:
            "url(" + require("images/malas/infopage_mobile2_06.jpg") + ")",
          backgroundPositionX: "50%",
        }}
        width="100%"
      ></Box>
    </MediaBox>
    <MediaBox
      greaterThanOrEqual="tablet"
      height="701px"
      style={{
        backgroundImage: "url(" + require("images/malas/infopage_06.jpg") + ")",
        backgroundPositionX: "center",
      }}
      textAlign="center"
      width="100%"
    >
      <Typography
        as="p"
        color="white"
        fontSize="24px"
        left="50%"
        ml="-170px"
        position="relative"
        top="450px"
        width="560px"
      >
        Education is the right of every child. The Jahnavi Project is an
        initiative to improve education and educational infrastructure for the
        children of the villages, together with{" "}
        <Typography
          as="a"
          color="white"
          fontSize="24px"
          href="https://kashika.org"
        >
          Kashika.org
        </Typography>
      </Typography>
    </MediaBox>
    <MediaBox greaterThanOrEqual="tablet">
      <Box
        height="388px"
        style={{
          backgroundImage:
            "url(" + require("images/malas/infopage_07.jpg") + ")",
          backgroundPositionX: "center",
        }}
        width="100%"
      ></Box>
    </MediaBox>
    <Box mb="100px" mt="50px" textAlign="center">
      <Typography as="a" fontSize="30px" href="https://www.kashika.org/">
        KASHIKA.ORG
      </Typography>
      <Divider bg="grey.10" my={3} />
      <Typography as="a" fontSize="30px" href="http://www.heartpilgrim.org/">
        HEARTPILGRAM.ORG
      </Typography>
      <Divider bg="grey.10" my={3} />
      <Typography
        as={Link}
        data-lc="jahnavi-mala-project"
        fontSize="30px"
        to="/mala-collection"
      >
        SHOP OUR MALA COLLECTION
      </Typography>
    </Box>
  </Box>
)

export default JahnaviMala
